export const BUSINESS_TRAVELER_QUERY = `
  query MyQuery {
    loyalty_program {
      loyaltyMemberAccount {
        loyaltyMemberEligibility {
          deltaBusinessTraveler
        }
      }
    }
  }
`;
